import React from 'react';
import css from './EngagementSection.css';
import { SectionOurPartners } from '../../sectionsForClubs';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../../components';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { parse } from '../../../../util/urlHelpers';
import config from '../../../../config';

const { userTypeHorseowner } = config;

export default () => {
    const history = useHistory();
    const { role } = parse(history.location.search);
    return (
        <>
            <SectionOurPartners
                header={
                    <header className={css.header}>
                        <h2 className={css.subHeading}>Engagement</h2>
                        <p className={css.heading}>Gemeinsam für den Pferdesport von morgen</p>
                        <p className={css.description}>
                            Wir setzen uns für einen fairen und nachhaltigen Pferdesport ein.
                            Deshalb fördern wir gezielt Vereine und Veranstaltungen, die diese Werte
                            stärken. Gleichzeitig profitierst Du als Vereinsmitglied von
                            zusätzlichen Vorteilen wie z. B. kostenlosen Credits.
                        </p>
                    </header>
                }
            />
            <section className={css.root}>
                <header>
                    <h2 className={css.subHeading}>Kostenlos registrieren</h2>
                    <p className={css.heading}>Werde Teil der Community</p>
                    <p className={css.description}>
                        Werde Teil unserer Community und erhalte einen kostenlosen Zugang zu
                        hundertenPferdemenschen und Pferden mit wenigen Klicks. Leg heute noch los!
                    </p>
                </header>

                <footer className={css.footer}>
                    <Button
                        className={css.subLinkPrimary}
                        onClick={() =>
                            history.push(
                                createResourceLocatorString(
                                    role === userTypeHorseowner
                                        ? 'SignupRider'
                                        : 'SignupHorseowner',
                                    routeConfiguration()
                                )
                            )
                        }
                    >
                        Kostenlos registrieren
                    </Button>
                </footer>
            </section>
        </>
    );
};
